import type { ReactNode } from "react";
import { Div, Panel, PanelHeader } from "@vkontakte/vkui";

type PageProps = {
  title: string;
  children: ReactNode;
};

export function Page({ title, children }: PageProps) {
  return (
    <Panel id="main" className="page">
      <PanelHeader>{title}</PanelHeader>
      <Div className="page-content">{children}</Div>
    </Panel>
  );
}
